
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.1 17c1.064-.032 3.146.038 4.06-1.354.901-1.37.71-4.382.629-5.945-.21-1.853-.148-5.623.725-6.816C7.432 1.63 8.302 1.1 10.09 1","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M1.1 17c1.064.032 3.146-.038 4.06 1.354.901 1.37.71 4.382.629 5.945-.21 1.853-.148 5.623.725 6.816C7.432 32.37 8.302 32.9 10.09 33","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('circle',{attrs:{"cx":"15.091","cy":"10","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"19.091","cy":"10","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"23.091","cy":"10","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"15.091","cy":"24","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"19.091","cy":"24","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"23.091","cy":"24","r":"1","fill":"currentColor"}}),_c('path',{attrs:{"d":"M37.081 17c-1.063.032-3.145-.038-4.06 1.354-.9 1.37-.709 4.382-.628 5.945.21 1.853.148 5.623-.725 6.816C30.75 32.37 29.879 32.9 28.09 33","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M37.081 17c-1.063-.032-3.145.038-4.06-1.354-.9-1.37-.709-4.382-.628-5.945.21-1.853.148-5.623-.725-6.816C30.75 1.63 29.879 1.1 28.09 1","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    